<!--
해외오더번호 수정 컴포넌트
------------------------------------
-->
<template>
    <div :class="classObject">
        <div class="uk-flex uk-flex-middle">
            <!-- TASK-107 #6: 주문서(receipt) 아이콘+링크 삭제 (해외오더정보 수정 접근은 쉬핑네임/OTP 링크로 유지) -->
            <input class="uk-width-expand uk-text-middle" type="text" v-model.trim="inputBuyOrderCode" @keyup.enter="submit"
                   placeholder="해외오더번호" title="해외오더번호 : ENTER입력시 저장"/>
            <button class="uk-button uk-button-small uk-button-dg-w-dg" @click="submit" v-if="edited">입력</button>
            <i class="material-icons md-24 check" v-if="saved && edited === false">check</i>

            <!-- 복사하기 -->
            <copy class="ml-2" tooltip="해외오더번호 복사하기" :copy-text="oldBuyOrderCode"></copy>
        </div>

    </div>


</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // prodId
            prodId: Number,

            // buyOrderCode
            buyOrderCode: String,
        },
        data: function () {
            return {
                /**
                 * (string) 수정전 원본값
                 */
                oldBuyOrderCode: this.buyOrderCode,

                /**
                 * (string) 입력값
                 */
                inputBuyOrderCode: this.buyOrderCode,

                /**
                 * (bool) 저장완료여부
                 */
                saved: false,

            };
        },
        computed: {
            /**
             * 수정여부
             * @return boolean
             */
            edited() {
                return this.oldBuyOrderCode !== this.inputBuyOrderCode;
            },

            /**
             * 컴포넌트 전체에 대한 css 클래스
             *  @return Object
             */
            classObject()
            {
                return {
                    // 변경되었음
                    'edited': this.edited,
                    // 저장되었음
                    'saved': this.saved,
                };
            },
        },
        methods: {


            /**
             * submit
             */
            submit() {
                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/'+this.prodId+'/buy-order-code',
                        data: {
                            _token: this.csrfToken,
                            buy_order_code: this.inputBuyOrderCode,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    this.oldBuyOrderCode = this.inputBuyOrderCode;
                    this.saved = true;
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .mark-link {
        text-decoration: none;
        display: inline-flex;

        &:hover .mark {
            color: dodgerblue !important;
        }
    }
    .mark {
        margin-right: 2px;

    }
    input {
        font-size: 0.875rem;
        padding: 1px;
        height: 1.75rem;
    }
    button {
        font-size: 0.875rem;
        padding: 1px;
        height: 1.75rem;
        line-height: 1.75rem;
    }


    // 저장됨
    .saved {
        .mark {
            color: mediumseagreen !important;
        }
        input {
            border: 1px solid mediumseagreen !important;
        }
    }

    // 수정됨
    .edited {
        .mark {
            color: red !important;
        }
        input {
            border: 1px solid red !important;
        }
        button {
            border: 1px solid red !important;
            color: red !important;
        }
    }

    .check {
        color: mediumseagreen !important;
    }
</style>